export function handleNumber(string) {
    let number = string ? string.replace(/\D*/g, '') : '';
    return number
}